import * as Sentry from '@sentry/nuxt';

import { version } from './package.json';

Sentry.init({
  // If set up, you can use your runtime config here
  dsn: 'https://d6aacfd500929bbc0b102517b8f2c4c3@o4505866666115072.ingest.sentry.io/4505869801422848',
  release: version,
  enabled: process.env.NODE_ENV !== 'development',
});